/**
 * CommunityGuidelinesPage
 *
 * Static public page displaying the Community Guidelines.
 * Accessible without authentication.
 */
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { LegalDocumentPage } from './LegalDocumentPage';
import communityGuidelinesHtml from './content/communityGuidelines.html?raw';

export const CommunityGuidelinesPage = () => {
  const { l10n } = useLocale();
  return <LegalDocumentPage qaId="legal-community-guidelines" title={l10n.legal.communityGuidelines} htmlContent={communityGuidelinesHtml} />;
};
